import React from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { SignOut, Translate } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { clearExternalAccess } from '../utils/externalAccess';
import { useCurrentUser } from '../contexts/CurrentUserContext';

const dashboard = { to: '/dashboard', label: 'navDashboard', end: true };
const customApps = { to: '/custom-apps', label: 'navCustomApps' };
const flavors = { to: '/flavors', label: 'navFlavors' };
// Running a build and browsing its artifacts are one place in the menu.
const builds = { to: '/builder', label: 'navBuilds', alsoActiveOn: ['/builder', '/downloads'] };

function PublicHeader() {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { can } = useCurrentUser();
  const links = [dashboard, customApps, ...(can('flavor:manage') ? [flavors] : []), ...(can('build:run') ? [builds] : [])];

  const handleLogout = () => {
    clearExternalAccess();
    navigate('/login', { replace: true });
  };

  return (
    <header className="nav">
      <nav className="nav__pill" aria-label={t.primaryNavigation}>
        <Link className="nav__brand" to="/dashboard" aria-label="App Builder home">
          <span className="nav__mark" aria-hidden="true">TK</span>
          <span>App Builder</span>
        </Link>
        <div className="nav__links">
          {links.map(({ to, label, end, alsoActiveOn }) => {
            const forced = alsoActiveOn?.some((prefix) => pathname.startsWith(prefix));
            return <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav__link${isActive || forced ? ' is-active' : ''}`}>{t[label]}</NavLink>;
          })}
        </div>
        <div className="nav__actions">
          <button className="nav__action" type="button" onClick={toggleLanguage} aria-label={t.toggleLanguage}>
            <Translate size={18} aria-hidden="true" />
            <span>{language === 'en' ? 'ID' : 'EN'}</span>
          </button>
          <button className="nav__action" type="button" onClick={handleLogout} aria-label={t.logout}>
            <SignOut size={18} aria-hidden="true" />
            <span>{t.logout}</span>
          </button>
        </div>
      </nav>
    </header>
  );
}

export default PublicHeader;
